export const changeLevel1NameReducer = (state = "", action) => {
  switch (action.type) {
    case "CHANGE_LEVEL1DATA_NAME":
      return action.payload.level1Data;
    default:
      return state;
  }
};
